/**
 * String utility functions
 */
/**
 * Convert camelCase to Title Case
 * @param camelCase - The camelCase string to convert
 * @returns Title Case string
 */
function camelCaseToTitle(camelCase) {
    return camelCase
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, (str) => str.toUpperCase())
        .trim();
}
/**
 * Capitalize first letter of string
 * @param input - The string to capitalize
 * @returns Capitalized string
 */
function capitalize(input) {
    if (!input)
        return input;
    return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
}
/**
 * Format duration in seconds to human readable string
 * @param seconds - Duration in seconds
 * @returns Human readable duration string (e.g., "1h 30m 45s")
 */
function formatDuration(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;
    let result = '';
    if (hours > 0) {
        result += `${hours}h `;
    }
    if (minutes > 0) {
        result += `${minutes}m `;
    }
    if (remainingSeconds > 0 || result === '') {
        result += `${remainingSeconds}s`;
    }
    return result.trim();
}
/**
 * Generate hash code from string
 * @param str - The string to hash
 * @param seed - Optional seed for the hash function
 * @returns Hash code as number
 */
function hashCode(str, seed = 0) {
    let h1 = 0xdeadbeef ^ seed;
    let h2 = 0x41c6ce57 ^ seed;
    for (let i = 0, ch; i < str.length; i++) {
        ch = str.charCodeAt(i);
        h1 = Math.imul(h1 ^ ch, 2654435761);
        h2 = Math.imul(h2 ^ ch, 1597334677);
    }
    h1 =
        Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^
            Math.imul(h2 ^ (h2 >>> 13), 3266489909);
    h2 =
        Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^
            Math.imul(h1 ^ (h1 >>> 13), 3266489909);
    return 4294967296 * (2097151 & h2) + (h1 >>> 0);
}
/**
 * Convert decimal to base64
 */
function decimalToBase64(decimalString) {
    const decimal = typeof decimalString === 'string'
        ? parseInt(decimalString, 10)
        : decimalString;
    return decimal.toString(36);
}
/**
 * Convert decimal to base62
 */
function decimalToBase62(decimalString) {
    const decimal = typeof decimalString === 'string'
        ? parseInt(decimalString, 10)
        : decimalString;
    const base62 = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    if (decimal === 0)
        return '0';
    let result = '';
    let num = decimal;
    while (num > 0) {
        result = base62[num % 62] + result;
        num = Math.floor(num / 62);
    }
    return result;
}
/**
 * Convert base62 to decimal
 */
function base62ToDecimal(base62String) {
    const base62 = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let result = 0;
    for (let i = 0; i < base62String.length; i++) {
        const char = base62String[i];
        const value = base62.indexOf(char);
        result = result * 62 + value;
    }
    return result.toString();
}
/**
 * Format template string with parameters using simple replacement
 */
function formatTemplate(template, parameters) {
    return template.replace(/\{\{(\w+)\}\}/g, (match, key) => {
        return parameters[key] !== undefined ? String(parameters[key]) : match;
    });
}

export { base62ToDecimal, camelCaseToTitle, capitalize, decimalToBase62, decimalToBase64, formatDuration, formatTemplate, hashCode };
//# sourceMappingURL=string.esm.js.map
